// material-ui
'use client'

import { useTheme, styled } from "@mui/material/styles";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

// assets
import {getAllNotifications} from "@/app/services/admin/NotificacoesUsuario.services";
import { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Link } from 'next/link';

import "@/app/App.css";
import { useSelector } from "@/app/store";
import { dispatch } from "@/app/store";
import { setNotificacaoUsuario } from "@/app/store/slices/notificacaoUsuarios2";
import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators"
import NotificationReadAdministracao from "@/app/views/pages/application/mail/NotificationReadAdministracao";
import { useRouter } from 'next/navigation';


// styles
const ListItemWrapper = styled("div")(({ theme }) => ({
  cursor: "pointer",
  padding: 16,
  "&:hover": {
    background:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.primary.light,
  },
  "& .MuiListItem-root": {
    padding: 0,
  },
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = () => {
  const theme = useTheme();
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  const [sedeID, setSedeID] = useState(null);
  const [usuarioID, setUsuarioID] = useState(null);
  const [notiicacaoTable, setNotiicacaoTable] = useState([]);
  const [userImage, setUserImage] = useState("");
  const intl = useIntl();
  const [url, setUrl] = useState(getBaseURL());  // backend URL

  const [typeUtilisateur, settypeUtilisateur] = useState("");
  const [openReadMessagemAdminins, setopenReadMessagemAdminins] = useState(false);
  const [dadosparams, setdadosparams] = useState([]);

  const router = useRouter();

  useEffect(() => {
      paramMemoire.map((item) => {
      setUsuarioID(item.id);

      settypeUtilisateur(item.typeUtilisateur);

     //  console.log("item.typeUtilisateur ", item.typeUtilisateur);
     //  console.log("item.id ", item.id)
      
      if(Number(item.typeUtilisateur) <3) 
      {
      setUserImage(
        url + "/users/images?tipoDisplay=" + item.photofilename
      );

     //  dispatch(getAllNotificacao(1, item.universityID, item.id));
       notificaoGet(item.universityID, item.id);
      }

      if(Number(item.typeUtilisateur) === 3) 
      {
      setUserImage(
        item.photofilename !== ""
        ? url + `/studentMatriculas/images?tipoDisplay=${item.photofilename}`
        : url + "/studentMatriculas/images?tipoDisplay=semfoto.png"
      );

     //  dispatch(getAllNotificacao(1, item.universityID, item.id));
     notificaoGetStudents(item.universityID, item.userID);
      }

    });
  }, [ usuarioID]);

  const chipSX = {
    height: 24,
    padding: "0 6px",
  };


  const chipWarningSX = {
    ...chipSX,
    color: theme.palette.warning.dark,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.warning.light,
  };

  const notificaoGet = async (unversityID1, userid1) => {
    try {
      
    
    await getAllNotifications(unversityID1, userid1, "messages_admin_Recus-non-lu").then(
      (response) => {
        setNotiicacaoTable(response.data);

        const dadosToSend = {
          row: {
            paramTable: response.data[0] || {},   // The entire row object
            mainID: response.data[0].notificacoesUsuarios_mainID || "",  // Use optional chaining to avoid errors
            mensagem: response.data[0].mensagem || "",  // Use optional chaining for safe access
            userFirstName : response.data[0].notificacoesUsuariosUser.firstname,
            userlastname : response.data[0].notificacoesUsuariosUser.lastname,
            photofilename : response.data[0].notificacoesUsuariosUser.photofilename

          }
        };

        setdadosparams(dadosToSend);  // envoyer les donnees pour readMessages

      }
      
    );
  } catch (error) {
      
  }
  };
  const notificaoGetStudents = async (unversityID1, userid1) => {

    await getAllNotifications(unversityID1, userid1, "messages_etudiant_Recus-non-lu").then(
      (response) => {

        console.log("messages_etudiant_Recus#### ", response.data);

        setNotiicacaoTable(response.data);
        const dadosToSend = {
          row: {
            paramTable: response.data[0] || {},   // The entire row object
            mainID: response.data[0].notificacoesUsuarios_mainID || "",  // Use optional chaining to avoid errors
            mensagem: response.data[0].mensagem || "",  // Use optional chaining for safe access
            userFirstName : response.data[0].firstname,
            userlastname : response.data[0].lastname,
            photofilename : response.data[0].photofilename
          }
        };

        setdadosparams(dadosToSend);  // envoyer les donnees pour readMessages

      }
    );
  };

  return (
    <>
    <List
      sx={{
        width: "100%",
        maxWidth: 330,
        py: 0,
        borderRadius: "10px",
        [theme.breakpoints.down("md")]: {
          maxWidth: 300,
        },
        "& .MuiListItemSecondaryAction-root": {
          top: 22,
        },
        "& .MuiDivider-root": {
          my: 0,
        },
        "& .list-container": {
          pl: 7,
        },
      }}
    >
      {notiicacaoTable.map((item) => (
        <div key={item.id}>
          <ListItemWrapper
          >
            <ListItem alignItems="center">
              <ListItemAvatar>
                <Avatar
                  alt="nome"
                  src={
                    Number(item.group_beneficiaire) === 5 ?
                    url + `/users/images?tipoDisplay=${item.photofilename}&typeUtilisateur=1`
                    :
                    null
                  }
                />
              </ListItemAvatar>
              <Grid item xs={12}>
              <Chip
                size="small"
                label={item.firstname + " " + item.lastname}
                sx={{
                  color: theme.palette.background.default,
                  bgcolor: theme.palette.warning.dark,
                }}
              />

             {/*  <ListItemText
                primary={
                  item.notificacoesUsuariosUser.firstname + " " + item.notificacoesUsuariosUser.lastname
                }
              /> */}
              </Grid>
              <ListItemSecondaryAction>
                <Grid container justifyContent="flex-end">
                </Grid>
              </ListItemSecondaryAction>
            </ListItem>

            <Grid container direction="column" className="list-container">
              <Grid item xs={12} sx={{ pb: 0 }}>
              <Typography
                variant="subtitle2"
                component="a"
                style={{ cursor: "pointer" }}
               // onClick={() => handleNavigateToRead(dadosparams)}
              >
                {item.titulo}
              </Typography>

                <Grid item xs={12} sx={{mt:1}}>
                    <Typography variant="caption" display="block" gutterBottom>
                    {intl.formatMessage({ id: "data" })}: {item.data}
                      {' '} {intl.formatMessage({ id: "hora" })}: {item.hora}

                    </Typography>
                  </Grid>
                  
              </Grid>
            
              <Grid item xs={12}  sx={{mt:1}}>
                <Grid container>
                  <Grid item>
                    <button style={{color: "black", fontSize: "14px"}}
                      className={
                        "ButtonStatutDataGrid " +
                        "_" +
                        item.lida +
                        "Notificacao"
                      }

                       onClick={() => {
                      //   alert("kkkk33");
                     //   handleNavigateToRead(dadosparams);
 
                        <Typography
                          component={Link}

                          href={" /user/notifications/read/"}
                          variant="subtitle2"
                          color="primary"
                        />;
                        //alert("button click");
                      }}
                    >
                      {Number(item.lida) === 1
                        ? intl.formatMessage({
                            id: "notificacoesList_nao_lida",
                          })
                        : Number(item.lida) === 2
                        ? intl.formatMessage({ id: "notificacoesList_lida" })
                        : Number(item.lida) === 3
                        ? intl.formatMessage({
                            id: "notificacoesList_todas",
                          })
                        : Number(item.lida) === 4
                        ? intl.formatMessage({ id: "notificacoesList_nova" })
                        : null}
                      {/* {getStatusNotificacao(item.lida)} */}
                    </button>

                   
                   
                  </Grid>
                  <Grid item>
                    {Number(item.lida) === 3 ? (
                      <Chip label="Novas" sx={chipWarningSX} />
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItemWrapper>
          <Divider />
        </div>
      ))}
      <Divider />

    </List>
  
</>

    
  );
};

export default NotificationList;
